import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/videoData";

interface BreadcrumbItem {
  name: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm" itemScope itemType="https://schema.org/BreadcrumbList">
        <li className="flex items-center" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
          <Link to="/" className="text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap" itemProp="item">
            <span itemProp="name">首页</span>
          </Link>
          <meta itemProp="position" content="1" />
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <span className="mx-2 text-foreground-400">/</span>
            {item.path ? (
              <Link to={item.path} className="text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap" itemProp="item">
                <span itemProp="name">{item.name}</span>
              </Link>
            ) : (
              <span className="text-foreground-950 whitespace-nowrap" itemProp="name">{item.name}</span>
            )}
            <meta itemProp="position" content={`${index + 2}`} />
          </li>
        ))}
      </ol>
    </nav>
  );
}